export const env = {
  apiUrl: (import.meta.env.VITE_API_URL as string) ?? '/api',
} as const
